/* eslint-disable i18next/no-literal-string */
import { Box } from '@mui/material';
import { memo } from 'react';

import useIntegrationSellerOverviewPage from 'pages/IntegrationPage/hooks/useIntegrationSellerOverviewPage';
import { MarkdownDisplay } from 'shared/ui/MarkdownDisplay';

export const IntegrationOverviewPage = memo(() => {
  const { markdown, loading, sellerId } = useIntegrationSellerOverviewPage();

  return (
    <Box>
      <MarkdownDisplay
        markdown={markdown}
        isLoading={loading}
        sellerId={sellerId}
      />
    </Box>
  );
});
